<template>
    <div style="background-color: #fff; width: 100vw">
        <navbar active_screen="profile" back_path="/profile" />
        <div style="margin: 8px">
            <img
                v-for="i in 7"
                :key="i"
                :src="'/resources/images/method-of-use/' + i + '.jpg'"
                :style="{
                    width: $device == 'mobile' ? '100%' : '50%',
                    padding: '8px',
                }"
            />
        </div>
        <div v-if="$device != 'mobile'" class="copyright-section">© Copyright SCG Debenture Club. All Rights Reserved.</div>
    </div>
</template>
<script>
import navbar from '../../components/navbar';
export default {
    components: {
        navbar,
    },
    data: function () {
        return {};
    },
    methods: {},
};
</script>
<style scoped>
.dot {
    border-radius: 50%;
    width: 8px;
    height: 8px;
    display: inline-block;
    margin-left: 8px;
}
.slide {
    background-color: transparent;
    width: 100%;
    text-align: center;
}
.image {
    width: 100%;
}
</style>
